import {API_URL} from "../config";
import axios from "../utils/axios";

class StatisticsRepository
{
    getSuspiciousCameraEvents(filter) {
        return axios.get(API_URL + "/Statistics/SuspiciousCameraEvents", { params: filter });
    }

    getDailyCameraEvents(filter) {
        return axios.get(API_URL + "/Statistics/DailyCameraEvents", { params: filter });
    }

    getHourlyCameraEvents(filter) {
        return axios.get(API_URL + "/Statistics/HourlyCameraEvents", { params: filter });
    }
}

export default StatisticsRepository;
